(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["og-header-delivery"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('og-delivery-header')) {

    customElements.define(
      'og-delivery-header',

      class extends HTMLElement {


        connectedCallback() {

          this.panel =
            this.querySelector(
              '.og-header-delivery'
            );


          this.frame = 0;


          this.schedule = () => {

            cancelAnimationFrame(
              this.frame
            );


            this.frame =
              requestAnimationFrame(
                () => this.place()
              );

          };


          this.onSectionUnload = (event) => {

            /*
              ヘッダー再描画前に
              納期欄を元のセクションへ戻す
            */

            if (
              this.panel &&
              event.target !==
                this.closest('.shopify-section') &&
              (
                event.target.contains(this.panel) ||
                (
                  this.header &&
                  event.target.contains(this.header)
                )
              )
            ) {

              this.restore();

            }

          };


          window.addEventListener(
            'resize',
            this.schedule,
            { passive: true }
          );


          window.addEventListener(
            'load',
            this.schedule
          );


          document.addEventListener(
            'DOMContentLoaded',
            this.schedule
          );


          document.addEventListener(
            'shopify:section:load',
            this.schedule
          );


          document.addEventListener(
            'shopify:section:reorder',
            this.schedule
          );


          document.addEventListener(
            'shopify:section:unload',
            this.onSectionUnload
          );


          /*
            ヘッダーがすでに存在していれば
            即時配置
          */

          this.place();

        }



        restore() {

          if (!this.panel) return;


          /*
            元の位置では表示しない
          */

          this.panel.style.setProperty(
            'display',
            'none'
          );


          if (this.header) {

            this.header.classList.remove(
              'og-delivery-header-layout'
            );

          }


          if (
            this.panel.parentElement !== this
          ) {

            this.appendChild(
              this.panel
            );

          }


          this.header = null;

        }



        place() {

          if (!this.isConnected) return;


          this.panel =
            this.panel ||
            this.querySelector(
              '.og-header-delivery'
            );


          if (!this.panel) return;


          const header =
            document.querySelector(
              'header.header'
            );


          if (!header) {

            this.restore();

            return;

          }


          const icons =
            header.querySelector(
              '.header__icons'
            );


          const logo =
            Array.from(
              header.children
            ).find(
              (element) =>
                element.matches(
                  '.header__heading, .header__heading-link'
                )
            );


          if (
            this.header &&
            this.header !== header
          ) {

            this.restore();

          }


          this.header = header;



          /* ===================================================
             スマートフォン
             =================================================== */

          if (window.innerWidth < 750) {


            /*
              PC用3列レイアウトを解除
            */

            header.classList.remove(
              'og-delivery-header-layout'
            );


            /*
              ★トップページ以外

              納期表示も深緑バナーも
              完全非表示
            */

            if (
              this.panel.classList.contains(
                'og-header-delivery--mobile-subpage'
              )
            ) {


              /*
                PCからスマホ幅へ変更された場合、
                header内に残っているpanelを元へ戻す
              */

              if (
                this.panel.parentElement !== this
              ) {

                this.appendChild(
                  this.panel
                );

              }


              this.panel.style.setProperty(
                'display',
                'none'
              );


              return;

            }



            /*
              ★スマホ＋トップページのみ

              ヘッダー全体の直後へ配置
            */

            const headerSection =
              header.closest(
                '.shopify-section'
              ) || header;


            if (
              headerSection.nextElementSibling !==
              this.panel
            ) {

              headerSection.insertAdjacentElement(
                'afterend',
                this.panel
              );

            }


            this.panel.style.removeProperty(
              'display'
            );


            return;

          }



          /* ===================================================
             PC・タブレット
             =================================================== */


          /*
            必要なヘッダー要素がまだない場合は
            表示しない
          */

          if (!icons || !logo) {

            this.restore();

            return;

          }


          /*
            3列レイアウトを有効化
          */

          header.classList.add(
            'og-delivery-header-layout'
          );


          /*
            ロゴとアイコンの間へ
            納期表示を移動
          */

          if (
            this.panel.parentElement !== header ||
            logo.nextElementSibling !== this.panel
          ) {

            header.insertBefore(
              this.panel,
              logo.nextSibling
            );

          }


          /*
            正しい位置への移動後に表示
          */

          this.panel.style.removeProperty(
            'display'
          );

        }



        disconnectedCallback() {

          cancelAnimationFrame(
            this.frame
          );


          window.removeEventListener(
            'resize',
            this.schedule
          );


          window.removeEventListener(
            'load',
            this.schedule
          );


          document.removeEventListener(
            'DOMContentLoaded',
            this.schedule
          );


          document.removeEventListener(
            'shopify:section:load',
            this.schedule
          );


          document.removeEventListener(
            'shopify:section:reorder',
            this.schedule
          );


          document.removeEventListener(
            'shopify:section:unload',
            this.onSectionUnload
          );


          this.restore();

        }

      }

    );

  }


  } catch(e) { console.error(e); }
})();
})();
